import styled from 'styled-components';

import { PULSE } from '../../../../theme/tokens';

/** Trend pill — green by default, red/down when `$down`. Sets `color` so the
 *  inner Icon (currentColor) and `<Text>` both inherit the tone. */
export const Root = styled.span<{ $down: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  font-weight: 600;
  padding: 4px 6px;
  border-radius: 6px;
  white-space: nowrap;
  background: ${(p) => (p.$down ? PULSE.dangerBg : PULSE.successBg)};
  color: ${(p) => (p.$down ? PULSE.danger : PULSE.success)};
`;
